meedy.controller('meedy.popupWpAnnexController', ['$rootScope', '$scope', '$state', '$mdDialog', 'meedy.blobUtils', 'meedy.storedDocumentModel', 'meedyConfig',
    function ($rootScope, $scope, $state, $mdDialog, blobUtils, storedDocumentModel, config) {

        function setData() {

        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {
            $scope.downloadAnnex = function () {
				storedDocumentModel.getWpAnnex().then(function (file) {
					blobUtils.saveAsPdf(file, 'aneks_do_umowy.pdf');
				});
			};
            
            $scope.signAnnex = function () {
				storedDocumentModel.setWpAnnex();
				$mdDialog.hide();
			};
	
			$scope.remindLater = function () {
		        $mdDialog.hide();
			};
        }


        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
    }
]);